import { Dialog, DialogModule } from '@angular/cdk/dialog';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCommonModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { UserDataService } from 'src/app/services/user-data.service';
import { MatIconModule } from '@angular/material/icon';
import Swal from 'sweetalert2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatCommonModule,
    CommonModule,
    MatDialogModule,
    DialogModule,
    MatIconModule,
    NgbModule
  ]
})
export class ReportComponent implements OnInit {
  bugReportForm: FormGroup;
  submitted: boolean = false;
  bugReported: boolean;
  criticalNess: any;
  proofURL: string;
  proofImage: any;
  filename: any;
  loader = false
  userDetails: any;

  constructor(
    private dialog: MatDialog,
    private bugService: UserDataService,
    private fb: FormBuilder,
    // private dialogRef: MatDialog
  ) { }

  BugPriority = ['None', 'Just for your information', 'Nothing Urgent, can wait', 'I"m stuck, need assistance']

  ngOnInit(): void {
    this.bugReported = false;
    this.bugReportForm = this.fb.group({
      EmailId: ['', [Validators.required, Validators.email]],
      Title: ['', Validators.required],
      Description: ['', [Validators.required]],
    });
    const email = localStorage.getItem('EmailAddress');
    const loggedIn = localStorage.getItem('fmsUserLoggedIn')

    if (email && loggedIn) {
      this.bugReportForm.controls.EmailId.setValue(email);
      this.bugReportForm.get('EmailId').disable();
    }
  }

  onPrioritySelect(val) {
    this.criticalNess = val
  }

  onFileSelected(files: any) {
    const file: File = files[0];
    this.filename = files[0].name
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.proofURL = reader.result as string;
        this.proofImage = this.proofURL.split('base64,')[1];
      };
      reader.onerror = (error) => {
        // console.error('File reading error:', error);
        Swal.fire({
          title: 'File reading error:' + error,
          text: 'Please chose another file',
          color: 'White',
          background: '#23272F',
          confirmButtonColor: "#91B5FD",
          icon: "error",
          timer: 8000,
          footer: 'Report a bug if problem persists'
        })
      };
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.bugReportForm.valid && this.criticalNess) {
      this.bugReported = true;
      let payload = {
        EmailId: this.bugReportForm.get('EmailId').value,
        ...this.bugReportForm.value,
        CriticalNess: this.criticalNess,
        BugProof: this.proofImage,
        Portal: 'FMS'
      }
      //  
      this.bugService.reportBug(payload)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: any) => {
            this.bugReported = false;
            Swal.fire({
              title: 'Bug Reported successfully!',
              text: "Thank you for notifying us, we will get back to you soon.",
              color: 'White',
              background: '#23272F',
              confirmButtonColor: "#91B5FD",
              icon: "success",
              timer: 8000
            });
            this.filename = null;
            this.bugReportForm.reset();
            this.dialog.closeAll();
          }, error: (err) => {
            this.bugReported = false;
            this.dialog.closeAll();
            Swal.fire({
              title: 'An Error Occured!',
              text: "Please drop a mail to contact@skyeair.tech",
              color: 'White',
              background: '#23272F',
              confirmButtonColor: "#91B5FD",
              icon: "error",
              timer: 8000
            });
            // console.log(err);
          },
        })
    } else if (this.bugReportForm.invalid) {
      this.bugReportForm.markAllAsTouched();
    }
  }

  showBugReportForm = false;

  toggleBugReportForm(bugReportDialog: TemplateRef<any>) {
    this.dialog.closeAll();
    this.filename = null;
    this.bugReportForm.reset();
    this.dialog.open(bugReportDialog)
    const email = localStorage.getItem('EmailAddress');
    const loggedIn = localStorage.getItem('fmsUserLoggedIn')

    if (email && loggedIn) {
      this.bugReportForm.controls.EmailId.setValue(email);
      this.bugReportForm.get('EmailId').disable();
    }
  }
}
